<sl-titulo>
    {{ unloggedLayoutTitle | easyplaceholder: "Registro" }}
</sl-titulo>
<usuario-registrado></usuario-registrado>
